<script>
    import { onDestroy, onMount } from 'svelte'
    export let configs = []

    let STYLING_INTERVAL = 3000
    let timer
    let stylesOn

    onMount(async () => {
        timer = setInterval(() => {
            handleConfigs()
        }, STYLING_INTERVAL)
    })

    onDestroy(() => {
        clearInterval(timer)
    })

    async function handleConfigs() {
        if (!configs.length) return false
        stylesOn = stylesOn ? false : true
    }
</script>

<div class="bg-white overflow-hidden shadow rounded-lg">
    <div class="px-4 py-5 sm:p-6">
        <ul>
            {#each configs as config, index (config._id)}
                <li class="mb-4 p2 flex flex-row justify-between flex-auto">
                    <p
                        style={`font-family: ${stylesOn ? config.family : ''}; font-size: ${stylesOn ? config.fontSize : ''}px; color: ${stylesOn ? config.color : ''}; text-transform: ${stylesOn ? (config.upperCase ? 'uppercase' : 'none') : ''}; font-weight: ${stylesOn ? config.fontWeight : ''}; font-style: ${stylesOn ? (config.fontStyle === 'regular' ? 'normal' : config.fontStyle) : ''}; text-decoration:  ${stylesOn ? (config.underline ? 'underline' : 'none') : ''}; `}
                        class="duration-500 ease-in-out transform-all origin-center">
                        {`User ${index + 1}`}
                    </p>
                </li>
            {/each}
        </ul>
    </div>
</div>

<style>
</style>
